import { easepick, RangePlugin } from '@easepick/bundle';

const selectors = {
  dashboard: '.m__dashboard-performance',
  date_filter: '.date-filter',
  filter_btn: '.date-filter-arrow',
};

/**
 * Performance Dashboard Date filter.
 */
export function filterPerformanceDate() {
  const dashboard = document.querySelector(selectors.dashboard);
  const filters = document.querySelectorAll(selectors.date_filter);
  if (!dashboard || !filters.length) {
    return;
  }

  const pageDateFilters = [];
  filters.forEach(filterEl => {
    const dateFilter = new easepick.create({
      element: filterEl,
      // grid: 2,
      calendars: 1, // 2,
      delimiter: '-',
      format: 'MMMM DD',
      css: [
        'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
        '/wp-content/themes/mce/patterns/calendar-skin.css',
      ],
      setup(picker) {
        picker.on('select', (e) => {
          const { start, end } = e.detail;
          dashboard.setDateInterval(start, end);
          dashboard.loadAllItems();
        });
      },
      plugins: [
        RangePlugin,
      ],
      RangePlugin: {
        tooltipNumber(num) {
          return num - 1;
        },
        locale: {
          one: 'night',
          other: 'nights',
        },
      },
    });
    dateFilter.setDateRange(
      new Date(Date.parse(dashboard.dataset.startDate)),
      new Date(Date.parse(dashboard.dataset.endDate))
    );
    pageDateFilters.push(dateFilter);

    const btn = filterEl.parentElement.querySelector(selectors.filter_btn);
    if (btn) {
      btn.addEventListener('click', () => {
        dateFilter.show();
      });
    }
  });
}